import { IObservableFinisher } from '@classic/Betting-v2/Model/Observables/IObservableFinisher'
import ObservableResultsPage from '@classic/Betting-v2/Model/Observables/ObservableResultsPage'
import Guard from '@classic/AppUtils/Framework/Guard'

export interface Params {
  raceInformation: ObservableResultsPage
  raceFinishers: ko.ObservableArray<IObservableFinisher>
  showField: boolean
}

export class FinishersListViewModel {
  public raceInformation!: ObservableResultsPage
  public raceFinishers!: ko.ObservableArray<IObservableFinisher>
  public showField!: boolean

  constructor(params: Params) {
    Guard.notNull(params.raceInformation)

    this.raceInformation = params.raceInformation
    this.raceFinishers = params.raceFinishers
    this.showField = params.showField
  }
}
